export const GET_LIST_CURRICULUMS = '/curriculum/list';
export const GET_CURRICULUM_INFO = '/curriculum/getById';
export const CREATE_CURRICULUM = '/curriculum/create';
export const UPDATE_CURRICULUM = '/curriculum/update';
export const DELETE_CURRICULUM = '/curriculum/delete';


